import React from 'react'
import { StyledMap } from '@/components/styles'
import { CLINIC } from '@/lib/schema/constants'

const MAP_ZOOM = 15
const MAP_EMBED_SRC =
  `https://maps.google.com/maps?q=${CLINIC.geo.latitude},${CLINIC.geo.longitude}` +
  `&z=${MAP_ZOOM}&output=embed`

export default function ContactsMap() {
  return (
    <StyledMap>
      <iframe
        className="map-wrapper"
        src={MAP_EMBED_SRC}
        title={CLINIC.name}
        loading="eager"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    </StyledMap>
  )
}
